import React, { useState, useEffect, useRef } from "react";

// import { widgetUrlData } from "../../../molecules/election-brick-wall/election-data";
import {
  stateElections2024AllRecords,
  lokSabhaElectionData2024AllRecords,
  assemblyElection2024Records
} from "../../../molecules/election-brick-wall-with-search/election-data-2024";
import Headline from "../../../atoms/headline";
import { Link } from "@quintype/components";
// import ScrollSnap from "../../../molecules/ScrollSnap";
// import SingleStrokeRightArrow from "../../../atoms/icons/single-stroke-right-arrow";
import Cardimage from "../../../atoms/cardimage";
import Carousel from "../../../atoms/carousel";
import ElectionConstituencySearchBar from "../../../atoms/election-constituency-search-bar";

import "./election-widget.m.css";
import "../../../story-templates/story-elements/slide-show/slideshow-element.m.css";

// const Records = [...stateElections2024AllRecords, ...lokSabhaElectionData2024AllRecords];
const Records = [...assemblyElection2024Records];
function ElectionWidget({ story, electionWidgetUrl }) {
  const { slug, headline } = story;
  // const [activeState, setActiveState] = useState("Mizoram");
  // const [widgetUrl, setWidgetUrl] = useState(widgetUrlData["Mizoram"]);
  const [isMobile, setMobile] = useState(false);
  const [widgetHeight, setWidgetHeight] = useState(isMobile ? "600px" : "355px");
  const iframeRef = useRef(null);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }

    if (iframeRef.current) {
      setWidgetHeight(Math.floor(iframeRef.current.offsetWidth / 2) + "px");
    }
  }, []);

  // const handleStateTabChange = (statename) => {
  //   setActiveState(statename);
  //   setWidgetUrl(widgetUrlData[statename]);
  // };

  const sliderItems = [
    <div styleName="election-widget-wrapper">
      {/* <div styleName="tabs-wrapper">
        {Object.keys(widgetUrlData).map((statename) => (
          <div
            onClick={() => handleStateTabChange(statename)}
            styleName={`state-tab ${activeState === statename ? "active-tab" : ""}`}
          >
            {statename}
          </div>
        ))}
      </div> */}
      <iframe
        ref={iframeRef}
        src={electionWidgetUrl}
        width="100%"
        height={isMobile ? "620px" : "355px"}
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      ></iframe>
    </div>,
    <div styleName="slider-image-wrapper">
      <Link href={`/${slug}`}>
        <Cardimage story={story} aspectRatio={[2, 1]} imageType="image2x1" showVideoIcon={true} />
      </Link>
      {/* {isMobile && (
        <a href="/assembly-elections-2023" styleName="align-image">
          <img src="https://images.assettype.com/deccanherald/2023-12/f7eb9d52-4c93-4dae-8005-d214d731af9a/BANNER_ELECTION23.png" />
        </a>
      )} */}
    </div>
  ];

  return (
    <div styleName="main-wrapper">
      <Link href={`/${slug}`}>
        <div styleName="heading">
          <Headline
            text={headline}
            headerType={6}
            headerLevel={1}
            story={story}
            lineClamp={isMobile ? 3 : 2}
            isElectionWidget={true}
          />
        </div>
      </Link>

      <div styleName="wrapper">
        {/* <ScrollSnap
          leftArrow={
            <div
              className="arrow-wrapper"
              style={{ top: isMobile ? "185px" : "200px", left: isMobile ? "-30px" : "-15px", position: "absolute" }}
            >
              <SingleStrokeRightArrow />
            </div>
          }
          rightArrow={
            <div
              className="arrow-wrapper"
              style={{ top: isMobile ? "185px" : "200px", right: isMobile ? "-35px" : "-15px", position: "absolute" }}
            >
              <SingleStrokeRightArrow />
            </div>
          }
        >
          {isMobile ? (
            <div id="slideshow-image-wrapper">{sliderItems[0]}</div>
          ) : (
            sliderItems.map((item, index) => (
              <div key={index}>
                <div id="slideshow-image-wrapper">{item}</div>
              </div>
            ))
          )}
        </ScrollSnap> */}
        {isMobile ? (
          <div id="slideshow-image-wrapper">{sliderItems[0]}</div>
        ) : (
          <Carousel totalItems={2} slidesToShow={1} showBullets showArrows={false}>
            {sliderItems.map((item, index) => (
              <div key={index}>
                <div id="slideshow-image-wrapper">{item}</div>
              </div>
            ))}
          </Carousel>
        )}
      </div>

      <div styleName="cta-wrapper" className="election-widget">
        <div styleName="search-wrapper">
          <ElectionConstituencySearchBar Records={Records.slice(0, 70)} />
        </div>
        <Link styleName="cta-button" href="/delhi-assembly-elections-2025">
          Delhi Polls 2025 &#187;
        </Link>
      </div>
    </div>
  );
}

export default ElectionWidget;
